"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.circulateTabInside = void 0;
var getKeyboardFocusableElements_1 = require("./getKeyboardFocusableElements");
var keyCodes_1 = require("./keyCodes");
/**
 * The circulate tab is used for detecting tabbing
 * and shift-tabbing (reverse tab) inside a block of elements.
 * it finds the block's interactive elements and circulates the focus on them
 */
var circulateTabInside = function (node, event) {
    var _a;
    var modalFocusableElements = (0, getKeyboardFocusableElements_1.getKeyboardFocusableElements)(node);
    var numberOfFocusableElements = (_a = modalFocusableElements === null || modalFocusableElements === void 0 ? void 0 : modalFocusableElements.length) !== null && _a !== void 0 ? _a : 0;
    if (numberOfFocusableElements === 0) {
        return;
    }
    var modalFirstFocusableElement = modalFocusableElements[0];
    var modalLastFocusableElement = modalFocusableElements[numberOfFocusableElements - 1];
    var element = event.target;
    var tabIndex = element.tabIndex;
    if (event.keyCode === keyCodes_1.KeyCodes.TAB && event.shiftKey) {
        if ((modalFirstFocusableElement === null || modalFirstFocusableElement === void 0 ? void 0 : modalFirstFocusableElement.type) === 'radio') {
            var radioElements = modalFocusableElements.filter(function (element) { return element.type === 'radio'; });
            if (radioElements.includes(element)) {
                event.preventDefault();
                modalLastFocusableElement.focus();
            }
            return;
        }
        if (element === modalFirstFocusableElement || tabIndex === -1) {
            event.preventDefault();
            modalLastFocusableElement.focus();
            return;
        }
        if (element === modalLastFocusableElement) {
            event.preventDefault();
            modalFocusableElements[numberOfFocusableElements - 2].focus();
            return;
        }
    }
    if (event.keyCode === keyCodes_1.KeyCodes.TAB) {
        if (element === modalLastFocusableElement) {
            event.preventDefault();
            modalFirstFocusableElement.focus();
        }
    }
};
exports.circulateTabInside = circulateTabInside;
